import React from 'react';
import css from './PaymentTable.module.css';

export default function PaymentTable3(props) {
  const { style } = props;

  return (
    <table style={style} className={css.table}>
      <tr>
        <th>VERIFICATION REQUIREMENTS</th>
        <th className={css.planCol}></th>
        <th className={css.planCol}>VERIFIED</th>
      </tr>
      <tr>
        <td>Minimum 500 Hours of Documented Coaching Experience</td>
        <td></td>
        <td>Required</td>
      </tr>
      <tr>
        <td>At Least 2 Client Testimonials or References</td>
        <td></td>
        <td>Required</td>
      </tr>
      <tr>
        <td>ICF Credential (ACC, PCC, MCC) or 20+ Years Professional Experience</td>
        <td></td>
        <td>Required</td>
      </tr>
      <tr>
        <td>Completion of a Viveka Verification Call</td>
        <td></td>
        <td>Required</td>
      </tr>
    </table>
  );
}
